<template>
  
  <div>

    

    <transition name="fade-up" mode="out-in">
      <v-container v-if="loading" key="settings_loader">
        <v-layout>
          <div class="spinner">
            <div class="double-bounce1"></div>
            <div class="double-bounce2"></div>
          </div>
        </v-layout> 
      </v-container>
      <v-container v-else grid-list-lg fluid key="settings_content">
        <v-layout row justify-center>
          <v-flex style="max-width: 650px;">
            <v-layout row wrap class="text-xs-left">
              <v-flex xs12>
                <h3>Account</h3>
              </v-flex>
              <v-flex xs12 class="text-xs-center">
                Email: {{ user.email }}
              </v-flex>
              <v-flex xs12 sm4>
                <div class="field-label">*First Name</div>
                <v-text-field
                  v-model="userData.first_name"
                  solo
                  flat
                  hide-details
                ></v-text-field>
              </v-flex>
              <v-flex xs12 sm4>
                <div class="field-label">*Last Name</div>
                <v-text-field
                  v-model="userData.last_name"
                  solo
                  flat
                  hide-details
                ></v-text-field>
              </v-flex>

              <v-flex xs12 sm4>
                <v-dialog
                  ref="birthdayDialog"
                  v-model="birthdayDialog"
                  :return-value.sync="userData.birthday"
                  persistent
                  lazy
                  full-width
                  width="290px"
                >
                  <template v-slot:activator="{ on }">
                    <div class="field-label">*Date of Birth</div>
                    <v-text-field
                      :value="$moment(userData.birthday).format('L')"
                      hide-details
                      solo
                      flat
                      readonly
                      v-on="on"
                    ></v-text-field>

                  </template>
                  <v-date-picker 
                    ref="birthdayPicker"
                    v-model="userData.birthday" 
                    scrollable
                    :max="new Date().toISOString().substr(0, 10)"
                    min="1930-01-01"
                    @change="birthdaySave"
                    color="primary"
                  >
                    <v-spacer></v-spacer>
                    <v-btn flat color="primary" @click="birthdayDialog = false">Cancel</v-btn>
                    <v-btn flat color="primary" @click="$refs.birthdayDialog.save(userData.birthday)">OK</v-btn>
                  </v-date-picker>
                </v-dialog>
              </v-flex>
              <v-flex xs12>
                <div class="field-label">Phone Number</div>
                <v-layout row>
                  <v-flex xs4>
                    <country-select 
                      :prefill="userData.phone_country"
                      placeholder="Country"
                      short
                      :clearable="(userData.phone_country ? true : false)"
                      @on-change="userData.phone_country = ($event ? $event : null)"
                    ></country-select>
                  </v-flex>
                  <v-flex xs8>
                    <v-text-field
                      v-model="userData.phone"
                      placeholder="Number"
                      solo
                      flat
                      hide-details
                    ></v-text-field>
                  </v-flex>
                </v-layout>
              </v-flex>

              <v-flex xs12>
                <div class="field-label">Social Media Link</div>
                <v-text-field
                  v-model="userData.social_url"
                  solo
                  flat
                  placeholder="For Styling Purposes"
                  hide-details
                ></v-text-field>
              </v-flex>

              <v-flex xs12 class="mt-2">
                <v-layout row align-center justify-center>
                  <v-flex shrink>
                    <v-checkbox
                      v-model="receiveTexts"
                      style="display: inline-block;"
                      color="primary"
                      hide-details
                      class="mt-0"
                    ></v-checkbox>
                  </v-flex>
                  <v-flex shrink>
                    <span style="font-size: 1.1em;">I would like to receive text alerts about my orders</span>
                  </v-flex>
                </v-layout>
                <!--<v-layout row align-center justify-center>
                  <v-flex shrink>
                    <v-checkbox
                      v-model="receiveEmails"
                      style="display: inline-block;"
                      color="primary"
                      hide-details
                      class="mt-0"
                    ></v-checkbox>
                  </v-flex>
                  <v-flex shrink>
                    <span style="font-size: 1.1em;">I would like to receive email alerts about my orders</span>
                  </v-flex>
                </v-layout>-->
              </v-flex>
                  

              <v-flex xs12 class="text-xs-center mt-3 mb-5">
                <v-btn color="primary" @click="updateUserProfile()" :loading="userDataSaving">UPDATE</v-btn>
              </v-flex>
            </v-layout>
          </v-flex>
        </v-layout>

        <v-layout row justify-center>
          <v-flex style="max-width: 650px;">
            <v-layout row wrap class="text-xs-left">
              <v-flex xs12>
                <h3>Update Password</h3>
              </v-flex>

              <v-flex xs12>
                <div class="field-label">New Password</div>
                <v-text-field
                  v-model="tmpNewPassword"
                  flat
                  solo
                  hide-details
                  type="password"
                ></v-text-field>
              </v-flex>
              <v-flex xs12>
                <div class="field-label">Confirm New Password</div>
                <v-text-field
                  v-model="tmpNewPasswordConfirmation"
                  flat
                  solo
                  hide-details
                  type="password"
                ></v-text-field>
              </v-flex>

              <v-flex xs12 class="text-xs-center mt-3 mb-5">
                <v-btn color="primary" @click="updateUserPassword()" :loading="userPasswordSaving">UPDATE</v-btn>
              </v-flex>
            </v-layout>
          </v-flex>
        </v-layout>

        <v-layout row justify-center>
          <v-flex style="max-width: 650px;">
            <v-layout row wrap class="text-xs-left">

              <v-flex xs12>
                <div class="field-label">Refer your friends with this link!</div>
                <v-text-field
                  :value="referralUrl"
                  flat
                  solo
                  hide-details
                  readonly
                  ref="referralLink"
                  @click.native="copyReferralLink()"
                ></v-text-field>
              </v-flex>
            </v-layout>
          </v-flex>
        </v-layout>
      </v-container>
        
    </transition>
  </div>

</template>

<script>

import CountrySelect from '@/components/helpers/CountrySelect';


export default {
  name: 'AccountProfileSettings',
  components: {
    'country-select': CountrySelect
  },
  data () {
    return {
      loading: true,

      birthdayDialog: false,

      userData: {},
      userDataSaving: false,

      options: null,
      receiveTexts: false,
      receiveEmails: false,

      tmpNewPassword: null,
      tmpNewPasswordConfirmation: null,
      userPasswordSaving: false,
    }
  },
  mounted: function() {
    this.setDefaults('user');
    this.getDataFromApi();
  },
  watch: {
    user: {
      handler: function(newVal, oldVal) {
        this.setDefaults('user');
      },
      deep: true
    }
  },
  computed: {
    cdn: function() {
      return this.$root.cdn;
    },
    user: function() {
      return this.$store.getters.user;
    },
    referralUrl: function() {
      return process.env.VUE_APP_URL + 'auth/register?ref=' + this.user.referral_code;
    }
  },
  methods: {
    getDataFromApi: function() {
      this.loading = true;

      let params = [];
      params.push('fields=options');
      params.push('expand=options');
      this.$http.get('users/' + this.user.id + '?' + params.join('&'))
        .then(result => {
          this.options = result.data.options;
          for(let option of result.data.options) {
            if(option.meta_key == 'text_notifications' && option.meta_value) this.receiveTexts = true;
            if(option.meta_key == 'email_notifications' && option.meta_value) this.receiveEmails = true;
          }
          this.loading = false;
        })
        .catch(error => {
          this.$swal.fire('Error', 'There was an error loading your profile settings');
        })
    },

    birthdaySave (date) {
      this.$refs.birthdayDialog.save(date);
    },
    setDefaults: function(type) {
      if(type == 'user') {
        this.userData = {
          first_name: this.$store.getters.user.first_name,
          last_name: this.$store.getters.user.last_name,
          birthday: this.$store.getters.user.birthday,
          phone: this.$store.getters.user.phone,
          phone_country: this.$store.getters.user.phone_country,
          hear_about_us: this.$store.getters.user.hear_about_us,
          social_url: this.$store.getters.user.social_url,
          address_line_1: this.$store.getters.user.address_line_1,
          address_city: this.$store.getters.user.address_city,
          address_state: this.$store.getters.user.address_state,
          address_postal: this.$store.getters.user.address_postal,
          address_country: this.$store.getters.user.address_country
        }
      }
    },

    updateUserProfile: function(type) {
      let data = {};
      
      this.userDataSaving = true;
      data.first_name = this.userData.first_name;
      data.last_name = this.userData.last_name;
      data.birthday = this.$moment(this.userData.birthday).format("YYYY-MM-DD");
      data.phone = this.userData.phone;
      data.phone_country = this.userData.phone_country;
      data.social_url = this.userData.social_url;

      data.setOptions = {
        text_notifications: (this.receiveTexts ? 1 : 'null'),
        email_notifications: (this.receiveEmails ? 1 : 'null')
      }
      
      this.$http.put('users/' + this.user.id + '?expand=fit,style', data)
        .then(response => {
          this.$store.commit('setUser', response.data);
          this.$toast.fire('Profile Updated');
        })
        .catch(error => {
          
          let msg = 'There was a problem updating your profile. Please try again.';
          if(error.response.status == '422') {
            msg = '';
            for(let errmsg of error.response.data) {
              msg += '<div class="error--text">' + errmsg.message + '</div>';
            }
          }
          this.$swal.fire({
            title: 'Error', 
            html: msg
          });
        })
        .finally(() => {
          this.userDataSaving = false;
        });
    },

    updateUserPassword: function() {
      if(this.tmpNewPassword == '') {
        this.$swal.fire('Password Required', 'Your password can not be blank');
        return;
      }
      if(this.tmpNewPassword.length <= 4) {
        this.$swal.fire('Too Short', 'Your password must be longer than 4 characters');
        return;
      }
      if(this.tmpNewPassword != this.tmpNewPasswordConfirmation) {
        this.$swal.fire('Passwords Don\'t Match', 'The passwords you have entered to not match');
        return;
      }

      this.userPasswordSaving = true;

      let data = {
        newPassword: this.tmpNewPassword,
        newPasswordConfirm: this.tmpNewPasswordConfirmation
      };
      
      this.$http.put('users/' + this.user.id + '?expand=fit,style', data)
        .then(response => {
          this.$store.commit('setUser', response.data);
          this.tmpNewPassword = null;
          this.tmpNewPasswordConfirmation = null;

          this.$toast.fire('Password Updated');
        })
        .catch(error => {
          let msg = 'There was a problem updating your password. Please try again.';
          if(error.response.status == '422') {
            msg = '';
            for(let errmsg of error.response.data) {
              msg += '<div class="error--text">' + errmsg.message + '</div>';
            }
          }
          this.$swal.fire({
            title: 'Error', 
            html: msg
          });
        })
        .finally(() => {
          this.userPasswordSaving = false;
        });
    },

    updateCountry: function(val) {
      this.$set(this.userData, 'address_country', val);
    },

    copyReferralLink: function() {
      let ref = this;
      let url = this.referralUrl;
      this.$copyText(url).then(function (e) {
        ref.$toast.fire('Link Copied to clipboard');
      }, function (e) {
        /*ref.$toast.fire({
          title: 'Could not copy trip url to clipboad',
          type: 'error'
        });*/
      });
      this.$refs.referralLink.$el.children[0].children[0].children[0].children[0].select();
    }
  }
}
</script>
